import { render, staticRenderFns } from "./ModalUpdateMoneylenderLicenseExpiry.vue?vue&type=template&id=3a2954ba&scoped=true&"
import script from "./ModalUpdateMoneylenderLicenseExpiry.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateMoneylenderLicenseExpiry.vue?vue&type=script&lang=js&"
import style0 from "./ModalUpdateMoneylenderLicenseExpiry.vue?vue&type=style&index=0&id=3a2954ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2954ba",
  null
  
)

export default component.exports